import React from 'react'
import { ICustomFieldFormSetting } from '@user/store/entityFormSettings'
import { getStyles } from './hooks/useStyles'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'

type Props = {
  setting: ICustomFieldFormSetting
}

export function CustomSettingsDraggableCard(props: Props) {
  const { setting } = props
  const { name } = setting
  const styles = getStyles(useTheme())
  const theme = useTheme()
  return (
    <Box sx={{ ...styles.draggable, marginBottom: 0, marginTop: 0 }}>
      <Box sx={styles.row}>
        <Box sx={styles.actionContainer}>
          <div style={{ display: 'flex', paddingLeft: theme.spacing(1.5) }}>
            <DragIndicatorIcon sx={{ cursor: 'grab' }} fontSize="small" />
            <Box style={{ paddingLeft: theme.spacing(1.5) }}>
              <Typography>{name}</Typography>
            </Box>
          </div>
        </Box>
      </Box>
    </Box>
  )
}
